module.exports = __webpack_public_path__ + "img/minecraft_programming_for_children.e95e3a61.jpg";